import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthStore } from '../stores';
import { DASHBOARD_PATH } from '../constants';

export const redirectQrCodeGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | UrlTree => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const isAuthenticated = authStore.authenticated();
  const qrCodeId = route.queryParamMap.get('boxId');
  if (!qrCodeId) {
    return router.createUrlTree([]);
  }

  if (isAuthenticated) {
    return router.createUrlTree([DASHBOARD_PATH], {
      queryParams: { qrCodeId },
    });
  }
  return true;
};
